window.PoofEffectPool = [];
function poof(pos) {
    const e = window.PoofEffectPool.pop();
    e.object.setTranslationWorld(pos);
    e.active = true;
    window.SW.soundEffects.playSound(Sounds.whoosh);
}

WL.registerComponent('poof-effect', {
    /* Object to turn towards */
    player: {type: WL.Type.Object}
}, {
    start() {
        this.fb = this.object.getComponent('flipbook');
    },

    onActivate() {

        this.fb.active = true;
        /* Return to pool shortly after flipbook ended */
        setTimeout(() => this.active = false, 1000*(this.fb.duration + 0.2));
    },

    onDeactivate() {
        window.PoofEffectPool.push(this);
    },

    update() {
        this.object.lookAt(this.player.getTranslationWorld([]), [0, 1, 0]);
    }
});
